/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyAnswer from './survey-answer';
import SurveyAnswerDetail from './survey-answer-detail';
import SurveyAnswerUpdate from './survey-answer-update';
import SurveyAnswerDeleteDialog from './survey-answer-delete-dialog';

const SurveyAnswerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyAnswer />} />
    <Route path="new" element={<SurveyAnswerUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyAnswerDetail />} />
      <Route path="edit" element={<SurveyAnswerUpdate />} />
      <Route path="delete" element={<SurveyAnswerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyAnswerRoutes;
